import { withInstall } from '@lit-element/utils'
import Dialog from './src/dialog.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtDialog: SFCWithInstall<typeof Dialog> = withInstall(Dialog)
export default LtDialog

export * from './src/use-dialog'
export * from './src/dialog'
export * from './src/constants'
